import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';
import Stack from '@mui/system/Stack';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { acceptedUploadImages, MAX_UPLOAD_FILE_SIZE_IN_MB } from '../../../common/api';
import { hasErrors } from '../../../common/enums';
import { Campagne } from '../../../common/models/campagnes';
import { userLogged } from '../../../common/selectors/user';
import { campagneSlice } from '../../../common/store/campagnes';
import { editCampagneSlice } from '../../../common/store/editCampagneSlice';
import { AppState, appStore, campagneSelector } from '../../../common/store/store';
import { postData } from '../../api';
import Uploader from '../../front/Uploader';
import { FileLoader } from '../../Loaders';
import { Loading } from '../Loading';



export const EditCampagne = () => {

    const { id } = useParams();

    const user = useSelector((state: AppState) => userLogged(state));

    const [loading, setLoading] = React.useState(false);
    const campagne = useSelector((state: AppState) => campagneSelector.selectById(state, parseInt(id ?? '0')));
    const editingCampagne = useSelector((state: AppState) => state.editCampagne.campagne);

    const [err, setErr] = React.useState<ResponseError[] | undefined>();
    const navigate = useNavigate();
    React.useEffect(() => {
        if (campagne) {
            appStore.dispatch(editCampagneSlice.actions.update(campagne));
        }
    }, []);


    const onSaveClick = async () => {
        setLoading(true);
        try {
            const result = await postData<Campagne>('campagnes', editingCampagne);
            if (!hasErrors(result)) {
                setErr(undefined);
                appStore.dispatch(editCampagneSlice.actions.update(result));
                appStore.dispatch(campagneSlice.actions.upsertOne(result));
            } else {
                setErr(result);
            }
            setLoading(false);
        } catch (err) {
            alert('Un erreur a eu lieu');
            setLoading(false);
        }
    };

    const onChange = (p: Partial<Campagne>) => {
        appStore.dispatch(editCampagneSlice.actions.update(p));
    };

    if (!campagne) return <p>Not found</p>;

    return <Master>
        <Container maxWidth={false}>
            <Typography variant='h1'>{campagne.name}</Typography>
            {user?.isAdmin ? <Breadcrumbs>
                <Link to={'/admin/campagnes'} onClick={() => { navigate('/admin/franchises'); }}>Campagnes</Link>
                <Typography>{campagne.name}</Typography>
            </Breadcrumbs> : null}
            {loading ? <Loading /> : null}
            <Grid container columns={2}>

                <Grid item xs={2} sm={1} sx={{ p: 2 }}>
                    <Typography variant='h2'>Informations générales</Typography>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            label='Nom de la campagne'
                            name='name'
                            value={editingCampagne.name ?? ''}
                            onChange={(event) => {
                                onChange({ name: event.target.value });
                            }}
                            error={!!err?.find(p => p.param === 'name')}
                            helperText={err?.find(p => p.param === 'name')?.msg}
                        />
                        <TextField
                            fullWidth
                            label='Titre'
                            name='title'
                            value={editingCampagne.title ?? ''}
                            onChange={(event) => {
                                onChange({ title: event.target.value });
                            }}
                            error={!!err?.find(p => p.param === 'title')}
                            helperText={err?.find(p => p.param === 'title')?.msg}
                        />
                        <TextField
                            fullWidth
                            label='URI'
                            name='path'
                            value={editingCampagne.path ?? ''}
                            onChange={(event) => {
                                onChange({ path: event.target.value });
                            }}
                            error={!!err?.find(p => p.param === 'path')}
                            helperText={err?.find(p => p.param === 'path')?.msg ?? `L'URI doit débuter par un slash !!!`}
                        />
                        <TextField
                            fullWidth
                            label='Afficher le composant de la route'
                            name='componentRoute'
                            value={editingCampagne.componentRoute ?? ''}
                            onChange={(event) => {
                                onChange({ componentRoute: event.target.value });
                            }}
                            error={!!err?.find(p => p.param === 'componentRoute')}
                            helperText={err?.find(p => p.param === 'componentRoute')?.msg}
                        />
                        <TextField
                            fullWidth
                            multiline
                            rows={6}

                            label='Description affiché par défaut'
                            name='description'

                            value={editingCampagne.description ?? ''}
                            onChange={(event) => {
                                onChange({ description: event.target.value });
                            }}
                            error={!!err?.find(p => p.param === 'description')}
                            helperText={err?.find(p => p.param === 'description')?.msg}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={2} sm={1} sx={{ p: 2 }}>

                    <Stack spacing={2}>
                        <Box
                            sx={{ margin: '2em 0' }}>
                            <Typography variant='h2'>Dépôt de documents et plans</Typography>
                            <Typography>Merci de bien vouloir fournir tout les documents pertinents au sujet de votre projet; tel que plans, devis, certificat de localisation, images, photos, croquis, etc. <strong>Seulement les image (JPEG / PNG) et documents pdf sont autorisés</strong>. Poid maximum des fichiers : {MAX_UPLOAD_FILE_SIZE_IN_MB} Mo.</Typography>
                            <Uploader acceptedUploadFiles={acceptedUploadImages} multiple={false} onChange={(files: number[]) => {
                                onChange({ imageId: files[0] });
                            }} />
                        </Box>
                        {editingCampagne.imageId ? <FileLoader id={editingCampagne.imageId} children={(file) => {
                            return <img src={file.url} />;
                        }} /> : null}
                    </Stack>
                </Grid>

                <Grid item xs={2} sx={{ p: 2, textAlign: 'center' }}>
                    <Button disabled={loading} size='large' variant='contained' onClick={onSaveClick}>Sauvegarder</Button>
                </Grid>
            </Grid>
        </Container>
    </Master>;
};
